import anime from 'animejs';

export default {
  state: {
    cursorType: '',
    rotateCursor: false,
    loading: {
      value: 0,
      status: false
    },
    negativeCursor: false,
  },
  mutations: {
    changeCursor(state, type) {
      state.cursorType = type
    },
    rotateCursor(state) {
      clearTimeout(c);
      state.rotateCursor = true;
      var c = setTimeout(() => {
        state.rotateCursor = false;
      }, 800);
    },
    loadingCursor(state, status) {
      if (status === true) {
        state.loading.status = true;
        const tempAnime = anime({
          targets: state.loading,
          duration: 1500,
          easing: 'easeInOutCirc',
          value: [0, 100],
          complete: (anim) => {
            setTimeout(() => {
              state.loading.value = 0;
              state.loading.status = false;
            }, 750)
          }
        });
      }
    },
    resetLoading(state) {
      clearInterval(state.loadingInterval);
    },
    negativeCursor(state, status) {
      state.negativeCursor = status
    },
  },
  getters: {
    getCursor: state => {
      return state.cursorType
    },
    rotateCursor: state => {
      return state.rotateCursor
    },
    loadingCursor: state => {
      return state.loading.status
    },
    negativeCursor: state => {
      return state.negativeCursor
    },
    loadingState: state => {
      return Math.floor(state.loading.value) + '%';
    }
  }
}